import { render, staticRenderFns } from "./introduceVideo.vue?vue&type=template&id=b9c07422&scoped=true"
import script from "./introduceVideo.vue?vue&type=script&lang=js"
export * from "./introduceVideo.vue?vue&type=script&lang=js"
import style0 from "./introduceVideo.vue?vue&type=style&index=0&id=b9c07422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c07422",
  null
  
)

export default component.exports